import { frontendURL } from '../../../../helper/URLHelper';
import { REDIS_FEATURE_FLAGS } from '../../../../featureFlags';

const PROJECT_INDEPENDENT = new Set(['claudia_create_project']);

const claudia = (
  accountId,
  { hasProjects = true, isHubAdmin = false } = {}
) => {
  const disabledFor = toStateName =>
    !hasProjects && !PROJECT_INDEPENDENT.has(toStateName);

  // Creating a project is a Hub-admin-only action (claudia enforces it on the
  // backend); hide the entry for everyone else instead of showing a screen
  // they can't use.
  const isVisible = toStateName =>
    isHubAdmin || toStateName !== 'claudia_create_project';

  return {
    parentNav: 'claudia',
    routes: [
      'claudia_create_project',
      'eddie_view',
      'eddie_view_legacy',
      'claudia_controlled_flows',
      'claudia_controlled_flows_catchall',
      'knowledge_base_view',
      'knowledge_base_view_catchall',
      'improvement_center_view',
      'improvement_center_view_catchall',
      'claudia_tools',
      'claudia_tools_catchall',
      'claudia_agents',
      'claudia_mcp',
      'claudia_settings',
      'claudia_deploy',
    ],
    menuItems: [
      {
        icon: 'add-circle',
        label: 'CLAUDIA_CREATE_PROJECT',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/claudia/create-project`),
        toStateName: 'claudia_create_project',
        disabled: disabledFor('claudia_create_project'),
        emphasized: !hasProjects,
      },
      {
        icon: 'settings',
        label: 'CLAUDIA_SETTINGS',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/claudia/settings`),
        toStateName: 'claudia_settings',
        featureFlag: REDIS_FEATURE_FLAGS.CLAUDIA_SETTINGS,
        disabled: disabledFor('claudia_settings'),
      },
      {
        iconType: 'claudia',
        icon: 'file',
        label: 'CLAUDIA_CONTENT',
        hasSubMenu: false,
        key: 'claudia_content',
        toState: frontendURL(`accounts/${accountId}/claudia/knowledge-bases`),
        toStateName: 'knowledge_base_view',
        newFeatureFlag: 'enable_knowledge_bases',
        disabled: disabledFor('knowledge_base_view'),
      },
      {
        iconType: 'claudia',
        icon: 'sparkle',
        label: 'CLAUDIA_IMPROVEMENT_CENTER',
        hasSubMenu: false,
        key: 'claudia_improvement_center',
        toState: frontendURL(
          `accounts/${accountId}/claudia/improvement-center`
        ),
        toStateName: 'improvement_center_view',
        newFeatureFlag: 'enable_improvement_center',
        disabled: disabledFor('improvement_center_view'),
      },
      {
        iconType: 'claudia',
        icon: 'coral',
        label: 'CLAUDIA_CONTROLLED_FLOWS_V2',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/claudia/controlled-flows`),
        toStateName: 'claudia_controlled_flows',
        disabled: disabledFor('claudia_controlled_flows'),
      },
      {
        // Cloud icon to match claudia-app's Agentes tab in the MF switcher
        // (react-feather `Cloud`). Uses a dedicated `cloud-line` key (not the
        // shared `cloud` Fluent icon, which the dashboard reuses for the API
        // inbox type) so the stroke restyle stays isolated to this sidebar.
        // `iconLib: 'lucide'` selects the stroke renderer — same convention as
        // the MCP `server` item above.
        icon: 'cloud-line',
        iconLib: 'lucide',
        label: 'CLAUDIA_CONVERSATIONAL_AGENTS',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/claudia/agents`),
        toStateName: 'claudia_agents',
        featureFlag: REDIS_FEATURE_FLAGS.CLAUDIA_AGENTS_V2,
        disabled: disabledFor('claudia_agents'),
      },
      {
        iconType: 'claudia',
        icon: 'repair-tools',
        label: 'CLAUDIA_TOOLS',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/claudia/tools`),
        toStateName: 'claudia_tools',
        featureFlag: REDIS_FEATURE_FLAGS.CLAUDIA_AGENTS_V2,
        disabled: disabledFor('claudia_tools'),
      },
      {
        // Server (rack) icon to match claudia-app's MCP tab in the MF switcher
        // (react-feather `Server`, same glyph as lucide). `iconLib: 'lucide'`
        // selects the stroke renderer so it draws outlined like the switcher,
        // not filled — same convention as the other stroke icons in the app.
        icon: 'server',
        iconLib: 'lucide',
        label: 'CLAUDIA_MCP_SERVERS',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/claudia/mcp`),
        toStateName: 'claudia_mcp',
        featureFlag: REDIS_FEATURE_FLAGS.CLAUDIA_AGENTS_V2,
        disabled: disabledFor('claudia_mcp'),
      },
      {
        iconType: 'claudia',
        icon: 'rocket',
        label: 'CLAUDIA_DEPLOY',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/claudia/deploy`),
        toStateName: 'claudia_deploy',
        featureFlag: REDIS_FEATURE_FLAGS.CLAUDIA_DEPLOY,
        disabled: disabledFor('claudia_deploy'),
      },
      {
        // Rendered as the bottom-pinned "CH Button" (orange surface) per the
        // Hub V2 sidebar Figma. Opens the Playground overlay instead of routing.
        iconType: 'fluent-v2',
        icon: 'flask-alt',
        label: 'CLAUDIA_PLAYGROUND',
        hasSubMenu: false,
        action: 'togglePlayground',
        pinnedToBottom: true,
        disabled: !hasProjects,
      },
    ].filter(item => isVisible(item.toStateName)),
  };
};

export default claudia;
